import Vue from 'vue'
import VueI18n from 'vue-i18n'
import ElementLocale from 'element-ui/lib/locale'
import elementEnLocale from 'element-ui/lib/locale/lang/en'  // elementui 的英文语言包
import elementJaLocale from 'element-ui/lib/locale/lang/ja' // elementui 的日文语言包
import elementTwLocale from 'element-ui/lib/locale/lang/zh-TW' // elementui 的繁体中文语言包
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN' // elementui 的中文语言包
import output_dicts from './lang' // 将对应的语言包引入
console.log('.......................', elementZhLocale)
Vue.use(VueI18n)

const messages = {
  'ja_JP': {  // 日文
    ...output_dicts.ja_JP,
    ...{
      el: {
        ...elementZhLocale.el, pagination: {
          goto: '行先ページ: ',
          pagesize: elementZhLocale.el.pagination.pagesize,
          total: 'データ数: {total}',
          pageClassifier: ''
        },
      }
    }
  },
  'en_US': {  // 英文
    ...output_dicts.en_US,
    ...{
      el: {
        ...elementZhLocale.el, pagination: {
          goto: 'Go To: ',
          pagesize: elementZhLocale.el.pagination.pagesize,
          total: 'Data: {total}',
          pageClassifier: ''
        },
      }
    }
  },
  'zh_CN': {  // 简体中文
    ...output_dicts.zh_CN,
    ...{
      el: {
        ...elementZhLocale.el, pagination: {
          goto: '前往页码: ',
          pagesize: elementZhLocale.el.pagination.pagesize,
          total: '数据总量: {total}',
          pageClassifier: ''
        },
      }
    }

  },
  'zh_TW': {  // 繁体中文
    ...output_dicts.zh_TW,
    ...{
      el: {
        ...elementZhLocale.el, pagination: {
          goto: '前往頁碼: ',
          pagesize: elementZhLocale.el.pagination.pagesize,
          total: '數據總量: {total}',
          pageClassifier: ''
        },
      }
    }
  },
}


const i18n = new VueI18n({
  locale: 'zh_CN',
  messages,
})
ElementLocale.i18n((key, value) => i18n.t(key, value))

export default i18n



// WEBPACK FOOTER //
// ./src/i18n.js